import React from 'react';
import { Play } from 'lucide-react';
import VideoFrame from '../components/VideoFrame';
import { mediaPlaylists } from '../mock';

const Media = () => {
  return (
    <div className="page-container">
      <section className="section-container">
        <h1 className="display-large page-title">Media</h1>
        <p className="body-large page-subtitle">
          Videos, debates, livestreams, and clips from our YouTube channel.
        </p>

        {/* Playlists */}
        <div className="playlists-section">
          <h2 className="display-medium section-title">Playlists</h2>
          <div className="playlists-grid">
            {mediaPlaylists.map((playlist, index) => (
              <div key={index} className="playlist-card">
                <div className="playlist-thumbnail">
                  <img src={playlist.thumbnail} alt={playlist.title} />
                  <div className="playlist-count">
                    <Play size={16} />
                    <span>{playlist.count} videos</span>
                  </div>
                </div>
                <h3 className="heading-3">{playlist.title}</h3>
              </div>
            ))}
          </div>
        </div>

        {/* Latest Videos */}
        <div className="videos-section">
          <h2 className="display-medium section-title">Latest Videos</h2>
          <div className="videos-grid-framed">
            <div className="video-card-framed">
              <VideoFrame 
                videoUrl="https://www.youtube.com/embed/dQw4w9WgXcQ"
                title="Understanding Free Grace Theology"
                logoPosition="bottom-right"
              />
              <div className="video-info">
                <h3 className="heading-3">Understanding Free Grace Theology</h3>
                <p className="body-small">45:32</p>
              </div>
            </div>

            <div className="video-card-framed">
              <VideoFrame 
                videoUrl="https://www.youtube.com/embed/dQw4w9WgXcQ"
                title="Debate: Does God Exist?"
                logoPosition="bottom-right"
              />
              <div className="video-info">
                <h3 className="heading-3">Debate: Does God Exist?</h3>
                <p className="body-small">1:23:15</p>
              </div>
            </div>

            <div className="video-card-framed">
              <VideoFrame 
                videoUrl="https://www.youtube.com/embed/dQw4w9WgXcQ"
                title="The Trinity Explained"
                logoPosition="bottom-right"
              />
              <div className="video-info">
                <h3 className="heading-3">The Trinity Explained</h3>
                <p className="body-small">38:47</p>
              </div>
            </div>
          </div>
        </div>

        {/* Shorts & Clips */}
        <div className="shorts-section">
          <h2 className="display-medium section-title">Shorts & Clips</h2>
          <p className="body-medium">
            Quick clips and highlights from our debates and teaching sessions.
          </p>
          <div className="shorts-grid">
            <div className="short-card">
              <div className="short-thumbnail">
                <img src="https://images.unsplash.com/photo-1499728603263-13726abce5fd?w=400" alt="Short" />
              </div>
              <p className="body-small">Faith Alone Explained</p>
            </div>
            <div className="short-card">
              <div className="short-thumbnail">
                <img src="https://images.unsplash.com/photo-1516981442399-a91139e20ff8?w=400" alt="Short" />
              </div>
              <p className="body-small">Quick Answer: Eternal Security</p>
            </div>
            <div className="short-card">
              <div className="short-thumbnail">
                <img src="https://images.unsplash.com/photo-1504052434569-70ad5836ab65?w=400" alt="Short" />
              </div>
              <p className="body-small">James 2 Clarified</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Media;
